module.exports = __webpack_public_path__ + "static/media/kong.94db5d4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/peaceSharkIndex/index/img/kong.png
// module id = 1454
// module chunks = 0